/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import { GridHeaderRowContext as l } from "./GridHeaderRowContainer.mjs";
import { GridContext as c } from "../../GridClientWrapper.mjs";
import { cloneReactElement as m } from "../../utils/index.mjs";
const x = (t) => {
  const o = n.useContext(c), r = n.useContext(l), i = {
    style: { ...o.getCellPositionStyle(t.column) }
  };
  return m(t.children, {
    onKeyDown: (e) => {
      r.cellKeyDown(e, t.column);
    },
    onContextMenu: (e) => {
      o.onContextMenu(e, void 0, t.column.field);
    },
    ...i
  });
};
export {
  x as GridHeaderCellElementContainer
};
